// src/pages/financeiro/FinanceiroContasPage.jsx
import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import LayoutDesktop from "../../layouts/LayoutDesktop";

export default function FinanceiroContasPage() {
  const { tema } = useTheme();

  return (
    <LayoutDesktop tema={tema} titulo="Financeiro" subtitulo="Cadastros / Contas">
      <section className="pc-card">
        <h2 style={{ marginTop: 0 }}>Cadastro de Contas</h2>
        <p style={{ marginTop: 8, lineHeight: 1.5 }}>
          Estrutura MVP para contas financeiras do grupo (bancos e caixa interno),
          usada como base para pagamentos, recebimentos e conciliação.
        </p>
        <ul style={{ marginTop: 10, lineHeight: 1.6 }}>
          <li>Nome da conta (ex.: Banco Inter - Conta Corrente)</li>
          <li>Tipo: Banco / Caixa / Carteira</li>
          <li>Banco, agência e número da conta</li>
          <li>Saldo inicial e data de abertura</li>
          <li>Status: Ativa / Inativa</li>
        </ul>

        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(15,23,42,0.25)" }}>
          <strong>Próximo passo sugerido:</strong>
          <div style={{ marginTop: 6, lineHeight: 1.5 }}>
            Criar CRUD completo em coleção dedicada (ex.: <code>financeiro_contas</code>) e usar essas contas como
            origem/destino em Lançamentos, Contas a Pagar e Receitas.
          </div>
        </div>
      </section>
    </LayoutDesktop>
  );
}
